module.exports = __webpack_public_path__ + "static/media/air-asia-tail.f85004e2.png";